import { useState, useCallback } from "react"
import { useDynamicElements } from "./useDynamicElements"
import { useLocation } from "react-router-dom"

export const useAutoSave = organizationId => {
  const { dispatches } = useDynamicElements()
  const location = useLocation()
  const pathname = location?.pathname || ""
  const isBankPath = pathname.includes("bancodeprecios/dynamic-element")
  const [savingRows, setSavingRows] = useState(new Set())
  const [successRows, setSuccessRows] = useState(new Set())

  const startSaving = useCallback(rowId => {
    setSavingRows(prev => new Set([...prev, rowId]))
    setSuccessRows(prev => {
      const newSet = new Set(prev)
      newSet.delete(rowId)
      return newSet
    })
  }, [])

  const stopSaving = useCallback((rowId, success = false) => {
    setSavingRows(prev => {
      const newSet = new Set(prev)
      newSet.delete(rowId)
      return newSet
    })

    if (success) {
      setSuccessRows(prev => new Set([...prev, rowId]))

      setTimeout(() => {
        setSuccessRows(prev => {
          const newSet = new Set(prev)
          newSet.delete(rowId)
          return newSet
        })
      }, 2000)
    }
  }, [])

  const autoSave = useCallback(
    async row => {
      const rowId = row.itemId

      startSaving(rowId)

      try {
        dispatches.setIsFromProject(!isBankPath)

        const from = isBankPath ? "bank" : "project"
        const isSuccess = await dispatches.editElement(
          row,
          organizationId,
          from,
        )
        stopSaving(rowId, isSuccess)
      } catch (error) {
        stopSaving(rowId, false)
      }
    },
    [dispatches, organizationId, startSaving, stopSaving, isBankPath],
  )

  const isSaving = useCallback(
    rowId => {
      return savingRows.has(rowId)
    },
    [savingRows],
  )

  const isSuccess = useCallback(
    rowId => {
      return successRows.has(rowId)
    },
    [successRows],
  )

  const shouldShowButton = useCallback(
    rowId => {
      return isSaving(rowId) || isSuccess(rowId)
    },
    [isSaving, isSuccess],
  )

  return {
    autoSave,
    isSaving,
    isSuccess,
    shouldShowButton,
  }
}
